import { makeStyles } from '@material-ui/core/styles';

import { blue, neutral } from 'shared/styles/colors';

import type { Variant } from './checkboxOption.type';

const VARIANT_STYLE = {
  default: {
    root: {
      padding: '0.75rem 1rem',
      border: 'none',
    },
  },
  card: {
    root: {
      padding: '1rem',
      border: `1px solid ${neutral['20']}`,
    },
  },
} as const;

export default makeStyles({
  root: ({ variant, fullWidth }: Props) => ({
    width: fullWidth ? '100%' : 'auto',
    margin: 0,
    padding: VARIANT_STYLE[variant].root.padding,
    gap: '0.75rem',
    color: neutral['100'],
    borderRadius: '1rem',
    border: VARIANT_STYLE[variant].root.border,
    '&.MuiFormControlLabel-labelPlacementStart': {
      justifyContent: 'space-between',
    },
  }),
  check: {
    width: '1.125rem',
    height: '1.125rem',
    padding: 0,
    color: neutral['50'],
  },
  checked: {
    color: blue['50'],
  },
  labelRoot: {
    display: 'flex',
    gap: '0.75rem',
    alignItems: 'center',
    '& *': {
      fontFamily: 'PP Object Sans',
    },
  },
  labelMain: {
    display: 'flex',
    gap: '0.25rem',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  labelTitle: {
    fontSize: '1rem',
    lineHeight: '1.125rem',
    fontWeight: 'bold',
  },
  labelDescription: {
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
    color: neutral['60'],
  },
});

interface Props {
  variant: Variant;
  fullWidth: boolean;
}
